import {createFileRoute} from '@tanstack/react-router';
import {BonusPointShopOrderPage} from 'pages/bonus/BonusPointShopOrderPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId/bonus-shop/order/$orderId',
)({
  component: BonusPointShopOrderPage,
  staticData: {crumbKey: 'navigation.bonus-shop.order'},
});
